import '@ssml-editor/core';
import '@ssml-editor/vue';
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { Effect } from '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                */
/* empty css                  */
/* empty css              */
/* empty css                           */
/* empty css                      */
/* empty css                  */
import '../voice/voice-menu.vue.js';

function generateSpeakUsageRecordLabel(dataListRate, dataListPitch, rate, pitch, volume, effect, effectValue) {
  let rateName = "";
  for (const r of dataListRate) {
    if (r.value === rate) {
      rateName = r.label;
      break;
    }
  }
  let pitchName = "";
  for (const p of dataListPitch) {
    if (p.value === pitch) {
      pitchName = p.label;
      break;
    }
  }
  const parts = [];
  parts.push(rateName);
  parts.push(pitchName);
  parts.push(`v${volume}`);
  if (effect) {
    parts.push(effect.toString());
    if ((effect === Effect.EQ || effect === Effect.LPFILTER || effect === Effect.HPFILTER) && effectValue) {
      parts.push(effectValue);
    }
  }
  return parts.join("-");
}

export { generateSpeakUsageRecordLabel };
//# sourceMappingURL=method.js.map
